/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
// import alert from 'react-s-alert';
import { omitEmptyArgs } from 'helper';
import * as c from './constant';

export const getUserManagementList = (payload = { sort_by: 'asc' }, callback) =>
  req.list(
    c.GET_USER_MANAGEMENT,
    'api/v1/administrators/administrators',
    payload,
    callback
  );

export const showUserManagement = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_USER_MANAGEMENT,
    `api/v1/administrators/administrators/${id}`,
    payload,
    callback
  );

export const createUserManagement = (payload, callback) =>
  req.create(
    c.CREATE_USER_MANAGEMENT,
    'api/v1/administrators/administrators',
    omitEmptyArgs(payload),
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateUserManagement = (id, payload, callback) =>
  req.update(
    c.UPDATE_USER_MANAGEMENT,
    `api/v1/administrators/administrators/${id}`,
    omitEmptyArgs(payload),
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateAdminPassword = (id, payload, callback) =>
  req.update(
    c.UPDATE_USER_MANAGEMENT,
    `api/v1/administrators/${id}/change_password`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const deleteUserManagement = (id, payload, callback) =>
  req.remove(
    c.DELETE_USER_MANAGEMENT,
    `api/v1/administrators/administrators/${id}`,
    payload,
    callback
  );

export const getRoleList = (
  payload = { is_paginated: 0, sort_by: 'asc' },
  callback
) =>
  req.list(c.GET_ROLE_LIST, 'api/v1/administrators/roles', payload, callback);

export const updateAdminStatus = (id, payload, callback) =>
  req.update(
    c.UPDATE_USER_STATUS,
    `api/v1/administrators/${id}/status`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );
